<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <!-- general tab -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">General</span>
      </template>

      <account-setting-general
        v-if="options.general"
        :general-data="options.general"
      />
    </b-tab>
    <!--/ general tab -->

    <!-- change password tab -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Cambiar Contraseña</span>
      </template>

      <account-setting-password />
    </b-tab>
    <!--/ change password tab -->

    <!-- payment -->
    <b-tab active>
      <!-- title -->
      <template #title>
        <feather-icon
          icon="DollarSignIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Pagos</span>
      </template>

      <account-setting-payment />
    </b-tab>

    <!-- notification -->
    <b-tab v-if="valid">
      <!-- title -->
      <template #title>
        <feather-icon
          icon="BellIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Cotizacion</span>
      </template>

      <account-setting-currency-price />
    </b-tab>
  </b-tabs>
</template>

<script>
import usePermission from "@/views/js/usePermission"
import { BTab, BTabs } from "bootstrap-vue"
import AccountSettingCurrencyPrice from "./AccountSettingCurrencyPrice.vue"
import AccountSettingGeneral from "./AccountSettingGeneral.vue"
import AccountSettingPassword from "./AccountSettingPassword.vue"
import AccountSettingPayment from "./AccountSettingPayment.vue"

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingPayment,
    AccountSettingCurrencyPrice,
  },
  setup() {
    const { valid } = usePermission(1)

    return { valid }
  },
  data() {
    return {
      options: {},
    }
  },
  beforeCreate() {
    this.$http.get("/account-setting/data").then((res) => {
      this.options = res.data
    })
  },
}
</script>
